module.exports = __webpack_public_path__ + "static/media/ag-products5.bb3ac81b.jpg";